import { supabase } from "./supabase_client.js";

export async function signup(email, password, username) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: { username },
    },
  });
  return { data, error };
}

export async function login(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  return { data, error };
}

export function getPasswordRecoveryRedirectUrl() {
  if (typeof window === "undefined") return undefined;
  const { origin, pathname } = window.location;
  const path = pathname.replace(/\/$/, "") || "";
  return path ? `${origin}${path}/` : `${origin}/`;
}

export async function requestPasswordResetEmail(email, redirectTo) {
  const { data, error } = await supabase.auth.resetPasswordForEmail(
    email.trim(),
    {
      redirectTo: redirectTo ?? getPasswordRecoveryRedirectUrl(),
    }
  );
  return { data, error };
}

export function describePasswordResetEmailError(error) {
  if (!error) return "Something went wrong.";
  const raw = (error.message || "").trim();
  const lower = raw.toLowerCase();
  const code = String(error.code || "").toLowerCase();
  if (
    lower.includes("rate limit") ||
    lower.includes("email rate limit") ||
    code === "over_email_send_rate_limit" ||
    code === "too_many_requests"
  ) {
    return (
      "Reset emails are temporarily limited for this address. " +
      "Please wait a few minutes before trying again. " +
      "Check your inbox and spam for a link you may have already received."
    );
  }
  return raw || "Something went wrong.";
}